<template>
	<div>

		<table class="data">
			<thead>
				<tr>
					<th></th>
					<th><h1>Entities</h1></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
				</tr>
				<tr>
					<th></th>
					<th></th>
					<th v-for="role in roles" :key="role.uuid">{{role.data.name.value}}</th>
					<th></th>
				</tr>
				<tr>
					<th></th>
					<th></th>
					<th class="multiple-checkboxes-labels" v-for="role in roles" :key="role.uuid + '*'">
						<span>View</span>
						<span>Add</span>
						<span>Edit</span>
						<span>Delete</span>
					</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="entity in content" :key="entity.id">
					<td></td>
					<td>
						{{entity.name}}
					</td>
					<td class="multiple-checkboxes" v-for="role in roles" :key="role.uuid + '-'">
						<template v-if="entity.privileges[role.data.name.value]">
							<input type="checkbox" :name="role.data.name.value + '_' + entity.id" :data-role-name="role.data.name.value" :data-role-uuid="role.uuid" :data-entity-id="entity.id" value="1" :checked="checkPrivilege(entity.privileges[role.data.name.value].value, 'canAccess')" @change="preparePostEntityPrivilege">
							<input type="checkbox" :name="role.data.name.value + '_' + entity.id" :data-role-name="role.data.name.value" :data-role-uuid="role.uuid" :data-entity-id="entity.id" value="2" :checked="checkPrivilege(entity.privileges[role.data.name.value].value, 'canCreate')" @change="preparePostEntityPrivilege">
							<input type="checkbox" :name="role.data.name.value + '_' + entity.id" :data-role-name="role.data.name.value" :data-role-uuid="role.uuid" :data-entity-id="entity.id" value="8" :checked="checkPrivilege(entity.privileges[role.data.name.value].value, 'canUpdate')" @change="preparePostEntityPrivilege">
							<input type="checkbox" :name="role.data.name.value + '_' + entity.id" :data-role-name="role.data.name.value" :data-role-uuid="role.uuid" :data-entity-id="entity.id" value="4" :checked="checkPrivilege(entity.privileges[role.data.name.value].value, 'canDelete')" @change="preparePostEntityPrivilege">
						</template>
						<template v-else>
							<input type="checkbox" :name="role.data.name.value + '_' + entity.id" :data-role-name="role.data.name.value" :data-role-uuid="role.uuid" :data-entity-id="entity.id" value="1" @change="preparePostEntityPrivilege">
							<input type="checkbox" :name="role.data.name.value + '_' + entity.id" :data-role-name="role.data.name.value" :data-role-uuid="role.uuid" :data-entity-id="entity.id" value="2" @change="preparePostEntityPrivilege">
							<input type="checkbox" :name="role.data.name.value + '_' + entity.id" :data-role-name="role.data.name.value" :data-role-uuid="role.uuid" :data-entity-id="entity.id" value="8" @change="preparePostEntityPrivilege">
							<input type="checkbox" :name="role.data.name.value + '_' + entity.id" :data-role-name="role.data.name.value" :data-role-uuid="role.uuid" :data-entity-id="entity.id" value="4" @change="preparePostEntityPrivilege">
						</template>
					</td>
					<td></td>
				</tr>
			</tbody>

			<thead>
				<tr><th>&nbsp;</th></tr>
				<tr>
					<th>&nbsp;</th>
					<th><h1>Pages</h1></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
				</tr>
				<tr>
					<th></th>
					<th></th>
					<th v-for="role in roles" :key="role.id">{{role.data.name.value}}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(page, key) in permissions.page" :key="key">
					<td></td>
					<td>
						{{key}}
					</td>
					<td v-for="role in roles" :key="role.id + '-'">
						<input type="checkbox" :name="role.uuid" :value="role.uuid" data-type="page" :data-name="key" :checked="checkPermission(page[role.uuid])" @change="postPermission">
					</td>
					<td></td>
				</tr>
			</tbody>

			<thead>
				<tr><th>&nbsp;</th></tr>
				<tr>
					<th>&nbsp;</th>
					<th><h1>Blocks</h1></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
				</tr>
				<tr>
					<th></th>
					<th></th>
					<th v-for="role in roles" :key="role.uuid">{{role.data.name.value}}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(block, key) in permissions.block" :key="key">
					<td></td>
					<td>
						{{key}}
					</td>
					<td v-for="role in roles" :key="role.uuid + '-'">
						<input type="checkbox" :name="role.uuid" :value="role.uuid" data-type="block" :data-name="key" :checked="checkPermission(block[role.uuid])" @change="postPermission">
					</td>
					<td></td>
				</tr>
			</tbody>

			<thead>
				<tr><th>&nbsp;</th></tr>
				<tr>
					<th>&nbsp;</th>
					<th><h1>States</h1></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
				</tr>
				<tr>
					<th></th>
					<th></th>
					<th v-for="role in roles" :key="role.uuid">{{role.data.name.value}}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(block, key) in permissions.states" :key="key">
					<td></td>
					<td>
						{{key}}
					</td>
					<td v-for="role in roles" :key="role.uuid + '-$'">
						<input type="checkbox" :name="role.uuid" :value="role.uuid" data-type="states" :data-name="key" :checked="checkPermission(block[role.uuid])" @change="postPermission">
					</td>
					<td></td>
				</tr>
			</tbody>
		</table>

	</div>
</template>

<script>

import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'permissions',
	props: ['content'],

	data () {
		return {
			roles: {},
			permissions: {}
		}
	},

	created () {
		this.fetchData()
	},

	updated () {
	},

	methods: {
		fetchData () {
			this.counter = 0
			document.querySelector('body').classList.add('loading')

			const urlPermissions = '/cms/api/permissions/fetch'
			xhrModule.get(urlPermissions, this.permissionsFetchCompleted.bind(this))

			// fetch all roles
			const urlRoles = '/cms/api/instances?where[entity]=roles&order=name'
			xhrModule.get(urlRoles, this.fetchRolesCompleted.bind(this))
		},

		permissionsFetchCompleted (data) {
			this.permissions = data.data
			this.loadingFinished()
		},

		fetchRolesCompleted (data) {
			// remove admin role from data
			data = data.data

			for (var i = 0; i < data.length; i++) {
				if (data[i].uuid === '11EA997CE21A8EA7AC16005056982405') {
					data.splice(i, 1)

					this.roles = data
					this.loadingFinished()

					return
				}
			}
		},

		loadingFinished () {
			this.counter++
			if (this.counter === 2) {
				document.querySelector('body').classList.remove('loading')
			}
		},

		checkPermission (data) {
			let bool = false
			if (data) bool = data.privileges_value == 1 ? true : 0

			return bool
		},

		postPermission (e) {
			const target = e.currentTarget
			const checked = target.checked
			const roleUUID = target.value
			const type = target.getAttribute('data-type')
			const name = target.getAttribute('data-name')
			let params = {}

			if (type === 'states') {
				params = {
					privileges_id: 0,
					privileges_referenced: name,
					privileges_references: 'states',
					privileges_role: roleUUID,
					privileges_state: 3,
					privileges_value: 0
				}
			} else {
				params = {
					privileges_id: 0,
					privileges_referenced: 0,
					privileges_references: `${type}:${name}`,
					privileges_role: roleUUID,
					privileges_state: 3,
					privileges_value: 0
				}
			}

			let permission = this.permissions[type][name][roleUUID] || params

			if (checked) {
				permission.privileges_value = 1
			} else {
				permission.privileges_value = 0
			}

			const json = JSON.stringify(permission)

			const url = '/cms/api/permissions/save'
			xhrModule.post(url, json, this.savePermissionCompleteHandler.bind(this))
		},

		preparePostEntityPrivilege (e) {
			const target = e.currentTarget
			const roleName = target.getAttribute('data-role-name')
			const roleUUID = target.getAttribute('data-role-uuid')
			const entityID = target.getAttribute('data-entity-id')
			const name = target.getAttribute('name')

			// find all related checkboxes
			const checkboxes = this.$el.querySelectorAll('input[type=checkbox][name="' + name + '"]')

			// calculate the privilege value
			let privilegeValue = 0
			for (var c = 0; c < checkboxes.length; c++) {
				if (checkboxes[c].checked) {
					privilegeValue = privilegeValue + parseInt(checkboxes[c].value)
				}

				if (c === checkboxes.length - 1) {
					// get entity
					for (var i = 0; i < this.content.length; i++) {
						if (this.content[i].id == entityID) {
							this.combinePrivilegeData(this.content[i], privilegeValue, roleName, roleUUID)
							return
						}
					}
				}
			}
		},

		combinePrivilegeData (entity, privilegeValue, roleName, roleUUID) {
			// check if there already is a privilege for this role
			if (entity.privileges[roleName]) {
				// edit value
				entity.privileges[roleName].value = privilegeValue
			} else {
				// create new object
				entity.privileges[roleName] = {
					id: 0,
					role: {
						id: roleUUID,
						name: roleName
					},
					state: 3,
					value: privilegeValue
				}
			}

			// post entity privilege
			const json = JSON.stringify(entity)
			const url = '/cms/api/entities'
			xhrModule.post(url, json, this.savePermissionCompleteHandler.bind(this))
		},

		savePermissionCompleteHandler (data) {
			general.saveAnimation()
		}
	}
}

</script>
